<template>
	<b-form-group label="Estado asignación">
		<b-input-group>
			<b-form-select
				@input="manageGetLocations()"
				autocomplete="off"
				:options="typeFilterOptions"
				v-model="selectedTypeFilter"
			></b-form-select>
		</b-input-group>
	</b-form-group>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import {
	BFormInput,
	BFormGroup,
	BInputGroupAppend,
	BInputGroup,
	BButton,
	BFormSelect,
	BFormCheckbox,
} from 'bootstrap-vue'
export default {
	components: {
		BFormCheckbox,
		BFormGroup,
		BFormInput,
		BInputGroupAppend,
		BInputGroup,
		BButton,
		BFormSelect,
	},
	data() {
		return {
			toggleAssigned: false,
		}
	},
	computed: {
		...mapState('tableFilters', ['input', 'typeFilterOptions']),
		selectedTypeFilter: {
			set(value) {
				this.setSelectedTypeFilter(value)
			},
			get() {
				return this.$store.state.tableFilters.selectedTypeFilter
			},
		},
	},
	methods: {
		manageGetLocations() {
			this.$emit('getLocations')
		},
		...mapMutations('locations', ['toggleAssignedLead']),
		...mapMutations('tableFilters', ['setInput', 'setSelectedTypeFilter']),
		cleanSearchBar() {
			this.setInput(null)
		},
	},
}
</script>
